import React from 'react';
import { useRefCallback } from '@bydesign-ui/hooks';
import { useCreateCascader } from '../../hooks/tree';
import { BaseTree } from '../tree/BaseTree';
export function MultipleTree(props) {
  var _props$accordion = props.accordion,
      accordion = _props$accordion === void 0 ? false : _props$accordion,
      _props$partialCheckAb = props.partialCheckAble,
      partialCheckAble = _props$partialCheckAb === void 0 ? true : _props$partialCheckAb,
      checkedStrategy = props.checkedStrategy,
      _props$spread = props.spread,
      spread = _props$spread === void 0 ? false : _props$spread,
      _props$selectToExpand = props.selectToExpand,
      selectToExpand = _props$selectToExpand === void 0 ? false : _props$selectToExpand,
      _props$selectedIds = props.selectedIds,
      selectedIds = _props$selectedIds === void 0 ? [] : _props$selectedIds,
      expandedIds = props.expandedIds,
      defaultExpandedIds = props.defaultExpandedIds,
      onExpand = props.onExpand,
      className = props.className,
      style = props.style,
      onSelect = props.onSelect,
      disabled = props.disabled,
      search = props.search,
      renderItem = props.renderItem,
      load = props.load,
      showLine = props.showLine,
      datasource = props.datasource,
      blockNode = props.blockNode;
  var handleSelect = useRefCallback(onSelect);

  var _useCreateCascader = useCreateCascader({
    value: selectedIds,
    expandedIds: expandedIds,
    defaultExpandedIds: defaultExpandedIds,
    onExpand: onExpand,
    multiple: true,
    datasource: datasource,
    spread: spread,
    partialCheckAble: partialCheckAble,
    checkedStrategy: checkedStrategy,
    onChange: handleSelect,
    disabled: disabled,
    accordion: accordion,
    load: load,
    selectToExpand: selectToExpand
  }),
      cascader = _useCreateCascader.cascader;

  return React.createElement(BaseTree, {
    className: className,
    style: style,
    search: search,
    cascader: cascader,
    renderItem: renderItem,
    multiple: true,
    blockNode: blockNode,
    showLine: showLine,
    disabled: disabled
  });
}